<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <loadingcomp
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{this.$t('Profitability')}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-text-field
              flat=""
              @keyup.enter="getKarlilikListPageOne()"
              solo-inverted=""
              hide-details
              v-model="karlilikListParams.Filtreler.SearchText"
               :label="this.$t('Search')"
              @click:append="getKarlilikListPageOne()"
              append-icon="live_help"
            ></v-text-field>
            <!-- <v-btn class="white--text" flat @click="paximumAdd()">
              Paximum Otel Ekle
              <v-icon right>add_box</v-icon>
            </v-btn> -->

            <v-btn class="white--text" flat @click="addDialogOpen()">
             {{this.$t('Add')}}
              <v-icon right>add_box</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-card class="pa-2">
            <v-layout row wrap align-center>
              <v-flex xs12 sm12 md3>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  label="Acente"
                  v-model="karlilikListParams.Filtreler.AcenteKodu"
                ></genelarama>
              </v-flex>

              <v-flex xs12 sm12 md1>
                <v-btn color="info" fab small @click="getKarlilikList()"
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>

              <v-flex
                xs12
                sm12
                md5
                class="headline font-weight-regular pl-3 grey--text"
              >
                {{ totalCountText }}
              </v-flex>
              <v-flex xs12 sm12 md2>
                <v-select
                  :label="$t('Sort-By')"
                  hide-details
                  :items="siralamaItems"
                  item-text="Text"
                  item-value="Value"
                  v-model="karlilikListParams.Paging.SiralamaTip"
                  @change="getKarlilikListPageOne()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md1>
                <v-select
                  :label="this.$t('Show')"
                  hide-details
                  :items="veriItem"
                  item-text="Text"
                  item-value="Value"
                  v-model="karlilikListParams.Paging.VeriAdet"
                  @change="getKarlilikListPageOne()"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex
          v-for="(item, index) in KarlilikList"
          :key="index"
          pa-3
          xs12
          sm12
          md12
        >
          <v-hover>
            <v-card
              width="100%"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              class="elevation-1 pa-3"
            >
              <v-layout row wrap align-center justify-end>
                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md12>
                          <v-icon style="color: #67768f" left>home_work</v-icon>
                          {{ item.AcenteAd }}</v-flex
                        >
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-icon style="color: #67768f" left>payment</v-icon>
                      {{ item.SaticiKod }} - {{ item.SaticiAd }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md6 style="color: #67768f"
                          > {{ $t('Start') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md6>{{
                          item.BasTarihi | dateformat
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md6 style="color: #67768f"
                          > {{ $t('Finish') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md6>{{
                          item.BitTarihi | dateformat
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md8 style="color: #67768f"
                          > {{ $t('Commission-Percentage') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md4>{{ item.KomYuzde }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md8 style="color: #67768f"
                          > {{ $t('Commission-Amount-v2') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md4>{{ item.KomTutar }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 style="color: #67768f"
                          >{{ $t('Money') }}:</v-flex
                        >
                        <v-flex xs12 sm12 md6>{{ item.Para }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 style="color: #67768f"
                          >{{ $t('Exchange-Rate-v2') }}:</v-flex
                        >
                        <v-flex xs12 sm12 md6>{{ item.Kur }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-layout row wrap>
                    <v-flex xs6 sm2 md6>
                      <v-btn
                        color="info"
                        @click="LoadKarlilik(item.Ref)"
                        outline
                        fab
                        small
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 sm2 md6>
                      <v-btn
                        color="error"
                        outline
                        fab
                        small
                        @click="deleteKarlilik(item.Ref)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <!-- sayfalama -->
        <v-flex xs12 sm12 md12>
          <v-layout justify-center>
            <template v-if="vmodelpagination">
              <div class="text-xs-center">
                <v-container>
                  <v-layout justify-center>
                    <v-flex xs8>
                      <v-pagination
                        :disabled="paginationDisabled"
                        color="info"
                        v-model="karlilikListParams.Paging.SayfaNo"
                        :length="totalResultCount"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="karlilikDialog" max-width="600px">
      <v-card flat color="grey lighten-4">
        <v-card-title> {{ this.$t('Profitability') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  label="Acente"
                  v-model="karlilikParams.Acente"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="true"
                  v-model="karlilikParams.TarihBilgisi.BasTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="karlilikParams.TarihBilgisi.BitTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Commission-Calculation-Method')"
                  v-model="karlilikParams.TarihBilgisi.Tip"
                  :items="komisyonHesaplaTip"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-checkbox :label="$t('All-v2')" v-model="karlilikParams.Tumu">
                </v-checkbox>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <v-select
                  clearable
                  :items="itemssaticitip"
                  item-text="Aciklama"
                  item-value="Kod"
                  :label="$t('Seller-Type')"
                  v-model="karlilikParams.SaticiTip"
                  hide-details
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="karlilikParams.SaticiTip"
                  v-model="karlilikParams.Satici"
                  label="Satıcı"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Exchange-Rate-v2')"
                  item-text="Title"
                  item-value="DovizKod"
                  @input="getKur(1)"
                  :items="doviztipi"
                  v-model="karlilikParams.Para"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field label="Kur" v-model="karlilikParams.Kur">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="karlilikParams.KomYuzde"
                  :label="$t('Commission-Percentage')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="karlilikParams.KomTutar"
                  :label="$t('Commission-Amount-v2')"
                >
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="karlilikDialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="addKarlilik()"
            >Kaydet</v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>

    <v-dialog v-model="karlilikUpdateDialog" max-width="600px">
      <v-card flat color="grey lighten-4">
        <v-card-title>Komisyon Güncelle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  label="Acente"
                  v-model="karlilikUpdateParams.Acente"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="true"
                  v-model="karlilikUpdateParams.TarihBilgisi.BasTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="karlilikUpdateParams.TarihBilgisi.BitTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Commission-Calculation-Method')"
                  v-model="karlilikUpdateParams.TarihBilgisi.Tip"
                  :items="komisyonHesaplaTip"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-checkbox :label="$t('All-v2')" v-model="karlilikUpdateParams.Tumu">
                </v-checkbox>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <v-select
                  clearable
                  :items="itemssaticitip"
                  item-text="Aciklama"
                  item-value="Kod"
                  :label="$t('Seller-Type')"
                  v-model="karlilikUpdateParams.SaticiTip"
                  hide-details=""
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  label="Satıcı"
                  :tip="karlilikUpdateParams.SaticiTip"
                  v-model="karlilikUpdateParams.Satici"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Exchange-Rate-v2')"
                  item-text="Title"
                  item-value="DovizKod"
                  @input="getKur(2)"
                  :items="doviztipi"
                  v-model="karlilikUpdateParams.Para"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field :label="$t('Exchange-Rate-v2')" v-model="karlilikUpdateParams.Kur">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="karlilikUpdateParams.KomYuzde"
                  :label="$t('Commission-Percentage')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="karlilikUpdateParams.KomTutar"
                  :label="$t('Commission-Amount-v2')"
                >
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="karlilikUpdateDialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="updateKarlilik()"
            >Kaydet</v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>

    <serviceacentekomisyon
      ref="serviceAcente"
      :SaticiTip="1"
      v-model="paximumOtel"
    ></serviceacentekomisyon>
  </div>
</template>

<script>
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import rez from "../rezervasyon";
import auth from "@/api/auth";
import serviceacentekomisyon from "@/components/app/coper/comp/serviceacentekomisyon.vue";

export default {
  data() {
    return {
      komisyonHesaplaTip: [
        {
          text: this.$t('Calculate-Per-Recording-Date'),
          value: 0,
        },
        {
          text: this.$t('Calculate-Per-Visitation-Date'),
          value: 1,
        },
      ],
      itemssaticitip: rez.SaticiTip,
      karlilikDialog: false,
      karlilikUpdateDialog: false,
      karlilikUpdateParams: {
        Ref: 0,
        Acente: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        Tumu: false,
        KomYuzde: null,
        KomTutar: 0,
        Para: "TL",
        Kur: 1.0,
        SaticiTip: 1,
        Satici: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        TarihBilgisi: {
          Tip: 0,
          BasTarihi: null,
          BitTarihi: null,
        },
      },
      karlilikParams: {
        Acente: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        Tumu: false,
        KomYuzde: null,
        KomTutar: 0,
        Para: "TL",
        Kur: 1.0,
        SaticiTip: 1,
        Satici: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        TarihBilgisi: {
          Tip: 0,
          BasTarihi: null,
          BitTarihi: null,
        },
      },
      totalCountText: null,
      siralamaItems: [
        {
          Text: this.$t('Ascending'),
          Value: 0,
        },
        {
          Text:this.$t('Descending'),
          Value: 1,
        },
      ],
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      loadingmesaj: "",
      loadingvmodel: false,
      text1: "",
      snackbar: false,
      totalResultCount: 1,
      vmodelpagination: false,
      paginationDisabled: false,
      paximumOtel: null,
      karlilikListParams: {
        Filtreler: {
          AcenteKodu: null,
          SearchText: null,
        },
        Paging: {
          SiralamaTip: 0,
          SayfaNo: 1,
          VeriAdet: 25,
        },
      },
      KarlilikList: [],
      islemTipi: null,
      kurList: [],
      doviztipi: [],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.kurCek();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  methods: {
    paximumAdd() {
      this.$refs.serviceAcente.dialogOpen();
    },
    addDialogOpen() {
      this.clearDialog(1);
      this.karlilikDialog = true;
    },
    clearDialog(clearTip) {
      var element = null;
      if (clearTip == 1) {
        element = this.karlilikParams;
      } else if (clearTip == 2) {
        element = this.karlilikUpdateParams;
      }

      element.Acente.YurtIci_YurtDisi = 0;
      element.Acente.CariKod = null;
      element.Acente.KDV = 0.0;
      element.Acente.id = "0";
      element.Acente.kod = "";
      element.Acente.isim = null;
      element.Acente.tip = 0;
      element.Acente.intField = null;
      element.Tumu = false;
      element.KomYuzde = null;
      element.KomTutar = 0;
      element.Para = "TL";
      element.Kur = 1.0;
      element.SaticiTip = 1;
      element.Satici.YurtIci_YurtDisi = 0;
      element.Satici.CariKod = null;
      element.Satici.KDV = 0.0;
      element.Satici.id = "0";
      element.Satici.kod = "";
      element.Satici.isim = null;
      element.Satici.tip = 0;
      element.Satici.intField = null;
      element.TarihBilgisi.Tip = 0;
      element.TarihBilgisi.BasTarihi = null;
      element.TarihBilgisi.BitTarihi = null;
    },
    updateKarlilik() {
      this.loadingvmodel = true;
      let params = null;
      if (this.karlilikUpdateParams.TarihBilgisi.BasTarihi == null) {
        params = {
          Ref: this.karlilikUpdateParams.Ref,
          Acente: this.karlilikUpdateParams.Acente,
          Tumu: this.karlilikUpdateParams.Tumu,
          KomYuzde: this.karlilikUpdateParams.KomYuzde,
          KomTutar: this.karlilikUpdateParams.KomTutar,
          Para: this.karlilikUpdateParams.Para,
          Kur: this.karlilikUpdateParams.Kur,
          SaticiTip: this.karlilikUpdateParams.SaticiTip,
          Satici: {
            YurtIci_YurtDisi: this.karlilikUpdateParams.Satici.YurtIci_YurtDisi,
            CariKod: this.karlilikUpdateParams.Satici.null,
            KDV: this.karlilikUpdateParams.Satici.KDV,
            id: this.karlilikUpdateParams.Satici.id,
            kod: this.karlilikUpdateParams.Satici.kod,
            isim: this.karlilikUpdateParams.Satici.isim,
            tip: this.karlilikUpdateParams.Satici.tip,
            intField: this.karlilikUpdateParams.Satici.null,
          },
          TarihBilgisi: null,
        };
      } else {
        params = this.karlilikUpdateParams;
      }
      tool.http_post(this, "KarlilikTanimlamaUpdate", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getKarlilikListPageOne();
            this.karlilikUpdateDialog = false;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.karlilikUpdateDialog = false;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.karlilikUpdateDialog = false;
          this.loadingvmodel = false;
        }
      );
    },
    LoadKarlilik(id) {
      //this.clearDialog(2);
      let params = {
        Id: id,
      };
      tool.http_post(this, "KarlilikTanimlamaTanimLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.data.TarihBilgisi == null) {
              var TarihBilgisi = {
                Tip: 0,
                BasTarihi: null,
                BitTarihi: null,
              };
              response.body.data.TarihBilgisi = Object.assign({}, TarihBilgisi);
            }
            if (response.body.data.Satici == null) {
              var satici = {
                YurtIci_YurtDisi: 0,
                CariKod: null,
                KDV: 0.0,
                id: "0",
                kod: "",
                isim: null,
                tip: 0,
                intField: null,
              };
              response.body.data.Satici = Object.assign({}, satici);
            }
            this.karlilikUpdateParams = response.body.data;
            this.karlilikUpdateDialog = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    addKarlilik() {
      this.loadingvmodel = true;
      let params = null;
      if (this.karlilikParams.TarihBilgisi.BasTarihi == null) {
        params = {
          Acente: this.karlilikParams.Acente,
          Tumu: this.karlilikParams.Tumu,
          KomYuzde: this.karlilikParams.KomYuzde,
          KomTutar: this.karlilikParams.KomTutar,
          Para: this.karlilikParams.Para,
          Kur: this.karlilikParams.Kur,
          SaticiTip: this.karlilikParams.SaticiTip,
          Satici: {
            YurtIci_YurtDisi: this.karlilikParams.Satici.YurtIci_YurtDisi,
            CariKod: this.karlilikParams.Satici.null,
            KDV: this.karlilikParams.Satici.KDV,
            id: this.karlilikParams.Satici.id,
            kod: this.karlilikParams.Satici.kod,
            isim: this.karlilikParams.Satici.isim,
            tip: this.karlilikParams.Satici.tip,
            intField: this.karlilikParams.Satici.null,
          },
          TarihBilgisi: null,
        };
      } else {
        params = this.karlilikParams;
      }
      tool.http_post(this, "KarlilikTanimlamaInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getKarlilikListPageOne();
            this.karlilikDialog = false;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.karlilikDialog = false;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.karlilikDialog = false;
          this.loadingvmodel = false;
        }
      );
    },
    getKur(tip) {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }
        tool
          .http_post(this, "KurAra", {
            tarih: this.kayitTarihi,
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(this.kurTipi, tip);
            },
            (response) => {
              this.val.Kur = 1;
            }
          );
      } else {
        this.selectKur(this.kurTipi, tip);
      }
    },
    selectKur(value, tip) {
      var resultSatis = this.kurList.find(this.paraAraSatis, tip);
      if (tip == 1) {
        if (resultSatis == undefined) {
          this.karlilikParams.Kur = 1;
        } else {
          this.karlilikParams.Kur = resultSatis.kur;
        }
      } else {
        if (resultSatis == undefined) {
          this.karlilikUpdateParams.Kur = 1;
        } else {
          this.karlilikUpdateParams.Kur = resultSatis.kur;
        }
      }
    },
    paraAraSatis(paraBirimi, tip) {
      if (tip == 1) {
        return paraBirimi.paraBirimi == this.karlilikParams.Para;
      } else {
        return paraBirimi.paraBirimi == this.karlilikUpdateParams.Para;
      }
    },
    kurCek() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    deleteKarlilik(Ref) {
      this.loadingvmodel = true;
      let params = {
        Id: Ref,
      };
      tool.http_post(this, "KarlilikTanimlamaDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getKarlilikListPageOne();
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    getKarlilikListPageOne() {
      this.karlilikListParams.Paging.SayfaNo = 1;
      this.getKarlilikList();
    },
    getKarlilikList() {
      this.KarlilikList = [];
      this.totalResultCount = 1;
      this.loadingvmodel = true;
      let params = null;

      if (this.karlilikListParams.Filtreler.AcenteKodu != null) {
        params = {
          Filtreler: {
            AcenteKodu: this.karlilikListParams.Filtreler.AcenteKodu.kod,
            SearchText: this.karlilikListParams.Filtreler.SearchText,
          },
          Paging: {
            SiralamaTip: this.karlilikListParams.Paging.SiralamaTip,
            SayfaNo: this.karlilikListParams.Paging.SayfaNo,
            VeriAdet: this.karlilikListParams.Paging.VeriAdet,
          },
        };
      } else {
        params = this.karlilikListParams;
      }

      tool.http_post(this, "KarlilikTanimlamaList", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.PageTotals.TotalCount > 0) {
              this.totalCountText =
               
                response.body.PageTotals.TotalCount +
                " " + this.$t('Number-of-Records-Found');
            } else {
              this.totalCountText = this.$t('No-Records-Found');
            }

            if (
              response.body.PageTotals.TotalCount >
              this.karlilikListParams.Paging.VeriAdet
            ) {
              this.totalResultCount = response.body.PageTotals.TotalPage;
              this.vmodelpagination = true;
              this.paginationDisabled = false;
            } else {
              this.totalResultCount = response.body.PageTotals.TotalPage;
              this.vmodelpagination = false;
              this.paginationDisabled = false;
            }

            this.KarlilikList = response.body.data;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
  },
  watch: {
    "karlilikListParams.Paging.SayfaNo": function () {
      this.getKarlilikListPageOne();
    },
  },
  components: {
    loadingcomp,
    yetkidialog,
    snackbarcomp,
    genelarama,
    tarihim,
    serviceacentekomisyon,
  },
  filters: {
    priceFormat: function (price) {
      return Number.parseFloat(price).toFixed(2);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
};
</script>

<style>
</style>